import dayjs from 'dayjs';
import { FC } from 'react';
import HomeIcon from '@/assets/home.svg';
import ProfileIcon from '@/assets/profile.svg';
import { strings } from '@/constants/strings';
import { Call } from '@/types/call';
import { cx } from '@/utils/cx';

export type CallsListItemProps = {
  call: Call;
  isLast?: boolean;
  label?: string;
};

function getLabelForCallerType(callerType: string) {
  switch (callerType) {
    case 'staff':
      return 'Staff';
    case 'ff':
      return 'Friends and Family App';
    default:
      return '';
  }
}

export const CallsListItem: FC<CallsListItemProps> = ({
  call,
  isLast,
  label,
}) => {
  const startTimeStamp = dayjs(call.placedAt);
  const startTime = {
    date: startTimeStamp.date(),
    month: startTimeStamp.format('MMM'),
    hour: startTimeStamp.hour(),
    minute: startTimeStamp.minute(),
    minuteString: '',
  };
  if (startTime.minute < 10) {
    startTime.minuteString = '0' + startTime.minute.toString();
  } else {
    startTime.minuteString = startTime.minute.toString();
  }

  const endTimeStamp = dayjs(call.endedAt);
  const endTime = {
    date: endTimeStamp.date(),
    month: endTimeStamp.format('MMM'),
    hour: endTimeStamp.hour(),
    minute: endTimeStamp.minute(),
    minuteString: '',
  };
  if (endTime.minute < 10) {
    endTime.minuteString = '0' + endTime.minute.toString();
  } else {
    endTime.minuteString = endTime.minute.toString();
  }

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <div
          className={cx(
            'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-400 text-white',
            call.caller?.type === 'staff' && 'bg-blue-400',
            call.caller?.type === 'ff' && 'bg-green-500',
          )}
        >
          {call.caller?.type === 'staff' && <ProfileIcon />}
          {call.caller?.type === 'ff' && <HomeIcon />}
          {!call.caller && <ProfileIcon />}
        </div>
        <div className="flex max-w-110 min-w-96 grow flex-row items-center justify-between gap-4 pl-3 text-sm text-gray-500">
          <div className="flex flex-col">
            {label ? (
              <div className="mb-1 w-fit rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700">
                {label}
              </div>
            ) : null}
            <div>
              Call placed at {startTime.month} {startTime.date},{' '}
              {startTime.hour}:{startTime.minuteString}
              {call.caller && (
                <span>
                  {' '}
                  by {call.caller.name} (
                  {getLabelForCallerType(call.caller.type)})
                </span>
              )}
            </div>
            <div>
              {call.callStatus === 'placed' && strings.calls.placed}
              {call.callStatus === 'opened' && strings.calls.opened}
              {call.callStatus === 'terminated' && strings.calls.terminated}
              {call.endedAt != call.placedAt &&
                ` at ${endTime.month} ${endTime.date}, ${endTime.hour}:${endTime.minuteString}`}
            </div>
            {call.endedBy === 'device' && (
              <div>{strings.calls.endedBy.device}</div>
            )}
            {call.endedBy === 'dmp' && <div>{strings.calls.endedBy.dmp}</div>}
          </div>
        </div>
      </div>
      <div className="h-8">
        {!isLast && <div className="mx-4 my-2 h-4 w-0.5 bg-gray-200"></div>}
      </div>
    </div>
  );
};
